import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import React, { useState } from "react";
import { FormGroup, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import SpinnerButton from "../../components/Button";

const SolucionModal = ({ ticket, isSavingTicket, handleTicketSave, toggle }) => {
  const [solucion, setSolucion] = useState(ticket.solucion);

  return (
    <Modal isOpen toggle={toggle}>
      <ModalHeader toggle={toggle}> Solucion del ticket </ModalHeader>
      <ModalBody>
        <FormGroup className="normalized_ul">
          <CKEditor
            editor={ClassicEditor}
            config={{
              removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
            }}
            data={solucion}
            onChange={(event, editor) => setSolucion(editor.getData())}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <FormGroup className="mb-0 px-3">
          <SpinnerButton className="btn btn-primary btn-block" isLoading={isSavingTicket} disabled={isSavingTicket} onClick={() => handleTicketSave({ solucion })}>
            Grabar
          </SpinnerButton>
        </FormGroup>
      </ModalFooter>
    </Modal>
  );
};

export default SolucionModal;
